import Cookies from 'js-cookie';

export default class CookieService {
    setCookie(key: string, value: string, expiration?: Date) {
        let opts: any = {};
        if (expiration) {
            opts.expiration = expiration.toUTCString();
        }

        Cookies.set(key, value, opts);
    }

    getCookie(key: string): string {
        return Cookies.get(key);
    }

    deleteCookie(key: string) {
        return Cookies.remove(key);
    }
};